'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _chatParser = require('./chatParser');
var _chatParser2 = _interopRequireDefault(_chatParser);
var _constants = require('../../constants');
var _chatManager = require('./chatManager');
var _chatManager2 = _interopRequireDefault(_chatManager);
var _lastTimestampHandler = require('../infra/lastTimestampHandler');
var _lastTimestampHandler2 = _interopRequireDefault(_lastTimestampHandler);
var _exceptions = require('../../exceptions');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function isLoadChatsResponse(stanza) {
  return stanza.is('iq') && stanza.getChild('chats');
}
function getSetInfo(stanza) {
  var set = stanza.getChild('chats').getChild('set');
  return set && set.getChildText('first');
}
var ChatHandler = function (_Plugin) {
  _inherits(ChatHandler, _Plugin);
  function ChatHandler(entity) {
    _classCallCheck(this, ChatHandler);
    var _this = _possibleConstructorReturn(this, (ChatHandler.__proto__ || Object.getPrototypeOf(ChatHandler)).call(this, entity));
    _this._notifySuccesfull = function (chats) {
      _this.entity.emit(_constants.Events.RECEIVED_CHATS, chats);
    };
    _this._notifyLoadChatsError = function (ex) {
      _this.entity.emit(_constants.Events.INTERNAL_ERROR, new _exceptions.LoadChatsException(ex.message));
    };
    _this._receivedChats = function (stanza) {
      if (isLoadChatsResponse(stanza)) {
        _this._notifySuccesfull(_this.chatParser.extract(stanza));
        _this._saveLastTimestamp(stanza);
      }
    };
    _this._saveLastTimestamp = function (stanza) {
      _this.lastTimestampHandler.updateFromIsoDate(getSetInfo(stanza));
    };
    _this.entity.on(_constants.Events.STANZA, _this._receivedChats);
    return _this;
  }
  return ChatHandler;
}(_plugin2.default);
ChatHandler.pluginName = 'chatHandler';
ChatHandler.deps = [_chatParser2.default, _chatManager2.default, _lastTimestampHandler2.default];
exports.default = ChatHandler;